<template>
  <div class="activistyMaterial">
    <div v-if="toolKitList.length > 0 && showSourceLink" class="common_group">
      <div class="title">
        <img src="@/assets/images/toolKitIcon.png">
        <span>{{ $t('newApp.activityInfo.tas') }}</span>
      </div>
      <ul class="toolKit">
        <li v-for="(item,index) in toolKitList" :class="index%2 !== 0 ? 'stripe ' : ''" :key="index">
          <div class="private">
            <img src="@/assets/images/toolKitIconfont.png">
            <span>{{ item.sourceName }}</span>
          </div>
          <el-button type="primary" @click="toolKitDownload(item)">
            <i class="iconfont icon-xiazai-Icon" />
            {{ $t('general.Download') }}
          </el-button>
        </li>
      </ul>
    </div>
    <div v-if="showHtTab" class="common_group">
      <div class="title">
        <img src="@/assets/images/dmIcon.png">
        <span>{{ $t('newApp.activityInfo.dmp') }}</span>
      </div>
      <iframe class="iframe-wrap common_group" :src="iframeUrl"></iframe>
      <!-- <commonTable ref="activistyMaterialTable" /> -->
    </div>
    <div v-if="qrCodeList.length > 0" class="QRcode common_group">
      <div class="title">
        <img src="@/assets/images/QRcodeIcon.png">
        <span>{{ $t('newApp.activityInfo.QR') }}</span>
      </div>
      <div class="content clear">
        <div v-for="(item,index) in qrCodeList" :key="index">
          <div class="image">
            <img v-lazy="item.url">
          </div>
          <span>{{ item.name }}</span>
        </div>
      </div>
    </div>
    <el-dialog :title="detailsTitle" width="1000px" :visible.sync="detailsDialogVisible">
      <commonTable ref="activistyMaterialDetailsTable" />
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import commonTable from 'components/commonTable';
import { TableColumns, TableRow } from '@/utils/tableOptions';
import { activityQueryDetails } from '../../service';
import Cookies from 'js-cookie';
export default {
  data () {
    return {
      tableData: [{}],
      detailsDialogVisible: false,
      activityCode: '',
      qrCodeList: [],
      toolKitList: [],
      detailsTitle: '',
      dmCustomerData: [],
      iframeUrl: '',
      showSourceLink: false,
      showHtTab: false,
    };
  },
  components: {
    commonTable
  },
  props: {
    echoData: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  computed: {
    ...mapState({
      userInfo: state => state.userInfo
    })
  },
  methods: {
    toolKitDownload (val) {
      let link = val.sourceLink;
      if (link) {
        // 解决直接写入变量路径，vue会进行路径拼接问题。
        if (link.indexOf('https') > -1) {
          let href = link.replace('https://', '');
          window.open('https://' + href);
        } else {
          let href = link.replace('http://', '');
          window.open('http://' + href);
        }
      }
    },
    detailsBtn (row) {
      this.detailsTitle = row.name.length > 15 ? `${row.name.substr(0, 15)}...` : row.name;
      activityQueryDetails.getDmCustomerData({ activityCode: this.activityCode, id: row.formUuid }).then(res => {
        if (res.status === '200') {
          this.dmCustomerData = res.data;
          this.detailsDialogVisible = true;
          if (this.$refs.activistyMaterialDetailsTable) this.$refs.activistyMaterialDetailsTable.pageData.pageNum = 1;
          this.loadDetailsTable();
        }
      });
    },
    downloadHandler (row) {
      activityQueryDetails.getDmCustomerData({ activityCode: this.activityCode, id: row.formUuid }).then(res => {
        if (res.status === '200') {
          let downloadData = res.data.map(item => {
            return {
              name: item.name,
              company: item.company,
              mobile: item.mobile,
              email: item.email,
              province: item.province,
              city: item.city,
              post: item.post,
              cooperationType: item.cooperationType,
              submitTime: item.submitTime
            };
          });
          let str = '<tr>' +
            '<td>姓名</td>' +
            '<td>公司</td>' +
            '<td>手机</td>' +
            '<td>邮箱</td>' +
            '<td>省份</td>' +
            '<td>城市</td>' +
            '<td>客户身份</td>' +
            '<td>签约类型</td>' +
            '<td>提交时间</td>' +
            '</tr>';
          // 增加\t为了不让表格显示科学计数法或者其他格式
          for (let i = 0; i < downloadData.length; i++) {
            str += '<tr>';
            for (const key in downloadData[i]) {
              str += `<td>${downloadData[i][key] + '\t'}</td>`;
            }
            str += '</tr>';
          }
          const worksheet = 'Sheet1';
          const uri = 'data:application/vnd.ms-excel;base64,';
          let template = `<html xmlns:o="urn:schemas-microsoft-com:office:office"
        xmlns:x="urn:schemas-microsoft-com:office:excel"
        xmlns="http://www.w3.org/TR/REC-html40">
        <head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet>
        <x:Name>${worksheet}</x:Name>
        <x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet>
        </x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]-->
        </head><body><table>${str}</table></body></html>`;
          let link = document.createElement('a');
          link.download = `${ row.name }.xls`;
          link.style.display = 'none';
          link.href = uri + window.btoa(unescape(encodeURIComponent(template)));
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
      });
    },
    loadDetailsTable () {
      let tableRow = new TableRow();
      tableRow.push(
        new TableColumns()
          ._title('姓名')
          ._data('name')
          ._width('10%')
      );
      tableRow.push(
        new TableColumns()
          ._title('公司')
          ._data('company')
          ._width('10%')
      );
      tableRow.push(
        new TableColumns()
          ._title('手机')
          ._data('mobile')
          ._width('11%')
      );
      tableRow.push(
        new TableColumns()
          ._title('邮箱')
          ._data('email')
          ._width('10%')
      );
      tableRow.push(
        new TableColumns()
          ._title('省份')
          ._data('province')
          ._width('10%')
      );
      tableRow.push(
        new TableColumns()
          ._title('城市')
          ._data('city')
          ._width('10%')
      );
      tableRow.push(
        new TableColumns()
          ._title('客户身份')
          ._data('post')
          ._width('10%')
      );
      tableRow.push(
        new TableColumns()
          ._title('签约类型')
          ._data('cooperationType')
          ._width('10%')
      );
      tableRow.push(
        new TableColumns()
          ._title('提交时间')
          ._data('submitTime')
          ._width('10%')
      );
      let column = tableRow._cols();
      this.$nextTick(() => {
        this.$refs.activistyMaterialDetailsTable.setColumn(column);
        this.$refs.activistyMaterialDetailsTable.loadStaticTable(this.dmCustomerData, this.dmCustomerData.length);
      });
    },
    loadTable () {
      let tableRow = new TableRow();
      tableRow.push(
        new TableColumns()
          ._title(this.$t('newApp.activityInfo.title'))
          ._data('name')
          ._cellType('customDom')
          ._cellData({
            formater: ({ row, column }) => {
              return (
                <div>
                  <span>{ row.name }</span>
                </div>
              );
            }
          })
      );
      tableRow.push(
        new TableColumns()
          ._title(this.$t('general.Operation'))
          ._width('250')
          ._cellType('customDom')
          ._cellData({
            formater: ({ row, column }) => {
              return (
                <div>
                  <el-button type="text" onClick={() => { this.detailsBtn(row); }}>{ this.$t('general.ctView') }</el-button>
                  <el-button type="text" onClick={() => { this.downloadHandler(row); }}>{ this.$t('general.Download') }</el-button>
                </div>
              );
            }
          })
      );
      let column = tableRow._cols();
      this.$nextTick(() => {
        this.$refs.activistyMaterialTable.setColumn(column, { page: false });
        // this.$refs.activistyMaterialTable.loadStaticTable(this.tableData);
        activityQueryDetails.getQrCode(this.activityCode).then(res => {
          if (res.status === '200') {
            this.qrCodeList = res.data;
          }
        }
        );
        this.$refs.activistyMaterialTable.loadTable({ url: '/dm/material/' + this.activityCode, method: 'get' });
      });
    },
    getToolKitData () {
      activityQueryDetails.getToolKitData(this.activityCode).then(res => {
        if (res.status === '200') {
          const {showSourceLink, showHtTab, activityCodeEncrypt} = res.data;
          this.showSourceLink = showSourceLink;
          this.showHtTab = showHtTab;
          this.toolKitList = res.data ? [ res.data ] : [];
          activityQueryDetails.getTicketEncrypt().then(res => {
            if (res.status === '200') {
              const ticket =  window.encodeURIComponent(res.data);
              const campaignNumber = window.encodeURIComponent(activityCodeEncrypt);
              // const datas = window.encodeURIComponent(this.userInfo.emailEncrypt);
              this.iframeUrl = `${window._env_.VUE_APP_HT_URL}/rjevent/rjEventConfig?campaignNumber=${campaignNumber}&data=${ticket}`
            }
          })
        }
      });
    }
  },
  mounted () {
    this.activityCode = this.echoData.marketActivity.activityCode;
    this.loadTable();
    this.getToolKitData();
  }
};
</script>

<style lang="scss" scoped>
@import "@/style/common";
.activistyMaterial{
  .toolKit{
    >li{
      background: #FCFDFE;
      padding: 12px 22px;
      @extend .clear;
      &.stripe{
        background: #F3F5F8;
      }
      >.private{
        float: left;
        height: 30px;
        line-height: 30px;
        >img{
          vertical-align: middle;
          margin-right: 10px;
        }
        >span{
          display: inline-block;
          vertical-align: middle;
        }
      }
      >.el-button{
        float: right;
        padding: 7px 14px!important;
        >span>i{
          font-size: 12px;
        }
      }
    }
  }
  >.QRcode{
    >.content{
      >div{
        width: 160px;
        float: left;
        &~div{
          margin-left: 50px;
        }
        >.image{
          width: 100%;
          height: 160px;
          background: #DCDFE6;
          margin-bottom: 16px;
          >img{
            width: 100%;
          }
        }
      }
    }
  }
  .iframe-wrap{
    height: 900px;
  }
}
</style>
